import { CommApiInstance } from "Utils/CommApiInstance";


const GameSvcMnyDpstPrdtCtntApi = async (
    gameSvcCd:string|null,
    prdtKindCd:string,
    prdtCd:string|null,

) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/${prdtKindCd}/${prdtCd}`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default GameSvcMnyDpstPrdtCtntApi;